(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';
const {FABRICS,EXTRA_TIES,HARDWARE,SIDE_PULLS,GLOWIRE,STAKES,PATCH_KITS}=window.SLDEstimatorData.products["trail_duster"];
const CONTROLS=window.SLDEstimatorData.productControls.originalTrailDuster;
  const FIELD_LABELS = Object.freeze({
    'Fabric/Color * (required)': 'Fabric/Color',
    'Extra Perimeter Tie Outs * (required)': 'Extra Perimeter Tie Outs',
    'Ground Tie Outs * (required)': 'Ground Tie Outs',
    'Side Panel Pull-Outs * (required)': 'Side Panel Pull Outs',
    "Reflective Guyline Cord * (required)": 'Reflective Guyline Cord:',
    'Tent Stakes * (required)': 'Tent Stakes',
    'Patch Kit * (required)': 'Patch Kit'
  });
  
  
  
  
  
  
  
  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  function selections(scope) {
    const selected = Object.create(null);
    for (const element of scope.querySelectorAll('select')) {
      const domLabel = clean(element.labels && element.labels[0] && element.labels[0].textContent);
      if (!own(FIELD_LABELS, domLabel)) continue;
      selected[FIELD_LABELS[domLabel]] = clean(element.value);
    }
    return selected;
  }
  function estimate(choice) {
    if (choice['Fabric/Color'] === 'Custom Fabric (Please Contact Me First)') return { manual: true };
    const fabric = FABRICS[choice['Fabric/Color']];
    const extraTies = EXTRA_TIES[choice['Extra Perimeter Tie Outs']];
    const hardware = HARDWARE[choice['Ground Tie Outs']];
    // Unsupported side-panel choices have no automatic estimate.
    if (!own(SIDE_PULLS, choice['Side Panel Pull Outs'])) return null;
    const sidePulls = SIDE_PULLS[choice['Side Panel Pull Outs']];
    const glowire = GLOWIRE[choice['Reflective Guyline Cord:']];
    const stakes = STAKES[choice['Tent Stakes']];
    const patchKit = PATCH_KITS[choice['Patch Kit']];
    if (!fabric || !extraTies || !hardware || sidePulls === undefined || glowire === undefined || stakes === undefined || patchKit === undefined) return null;
    const body = 111 * fabric.width / 1296 * fabric.density;
    const tieAssemblies = 4 * (4.5 * hardware.webbing + hardware.each) + (extraTies.count - 4) * (3.5 * hardware.webbing + hardware.each);
    const finished = body + extraTies.reinforcement + tieAssemblies + CONTROLS.hemThreadTreatment + sidePulls;
    const mainSack = window.SLDEstimatorData.shared.tarps.mainSackWeight(111*fabric.width,choice['Fabric/Color'] === 'Silpoly 1.6 (Choose from available solid colors at Ripstopbytheroll.com)',0);
    const packed = finished + mainSack + glowire;
    const complete = packed + stakes + patchKit;
    return { body, tieAssemblies, finished, mainSack, packed, complete };
  }
  function start() {
    const root = document.querySelector('[data-sld-trail-duster-estimator]');
    if (!root) return;
    const scope = root.closest('product-info') || document;
    const packedValue = root.querySelector('[data-sld-weight-packed]');
    if (packedValue) { const packedLabel = packedValue.previousElementSibling; if (packedLabel) packedLabel.remove(); packedValue.remove(); }
    const finishedValue = root.querySelector('[data-sld-weight-finished]');
    if (finishedValue && finishedValue.previousElementSibling) finishedValue.previousElementSibling.textContent = 'Tarp Weight';
    const completeValue = root.querySelector('[data-sld-weight-complete]');
    if (completeValue && completeValue.previousElementSibling) completeValue.previousElementSibling.textContent = 'Total Packed Weight';
    const caption = root.querySelector('[data-sld-estimator-results] .caption');
    if (caption) caption.textContent = 'Total packed weight includes the tarp, stuff sack, and all selected accessories. Weights are approximate and may vary slightly.';
    function calculate() {
      const result = estimate(selections(scope));
      const results = root.querySelector('[data-sld-estimator-results]');
      const message = root.querySelector('[data-sld-estimator-message]');
      if (!result || result.manual) {
        if (results) results.hidden = true;
        if (message) message.textContent = result && result.manual ? 'Custom fabrics require a manual weight estimate. Please contact me before ordering.' : 'Select the required options above to see the estimated weight.';
        return;
      }
      const set = (selector, value) => { const element = root.querySelector(selector); if (element) element.textContent = value.toFixed(1) + ' oz'; };
      set('[data-sld-weight-finished]', result.finished);
      set('[data-sld-weight-complete]', result.complete);
      if (results) results.hidden = false;
      if (message) message.textContent = '';
    }
    let timer;
    const queue = () => { clearTimeout(timer); timer = setTimeout(calculate, 75); };
    document.addEventListener('change', queue, true);
    document.addEventListener('input', queue, true);
    document.addEventListener('click', queue, true);
    new MutationObserver(queue).observe(scope, { subtree: true, attributes: true, attributeFilter: ['value', 'checked', 'selected', 'class', 'aria-checked'], childList: true });
    calculate();
  }
  return { estimate, selections, start };
});